import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@4.3.0_webpack@3.12.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sqlb",
  "use": "icon-sqlb-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sqlb\"><path d=\"M832 608c17.6 0 32 14.4 32 32v320a32 32 0 0 1-64 0v-320c0-17.6 14.4-32 32-32zM256 224h384a32 32 0 0 1 0 64H256a32 32 0 0 1 0-64zM256 416h384a32 32 0 0 1 0 64H256a32 32 0 0 1 0-64zM256 608h224a32 32 0 0 1 0 64H256a32 32 0 0 1 0-64z\" p-id=\"35452\" /><path d=\"M672 768h320a32 32 0 0 1 0 64h-320a32 32 0 0 1 0-64z\" p-id=\"35453\" /><path d=\"M736 32h-576a128 128 0 0 0-128 128v704a128 128 0 0 0 128 128H576v-64H160a64 64 0 0 1-64-64v-704a64 64 0 0 1 64-64h576a64 64 0 0 1 64 64v384h64v-384a128 128 0 0 0-128-128z\" p-id=\"35454\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sqlb.svg
// module id = bz3N
// module chunks = 38